import {
  Button,
  Card,
  editorConfigOptions,
  ErrorAlert,
  ErrorMessage,
  Header,
  Input,
  JoditEditor,
  SwitchInput,
  useCustomForm,
  useFetchData,
  useParams,
  useRef,
} from "@";
import { getPage, updatePage } from "./utils/api";
import { defaultValues, schema } from "./utils/validation";

const Edit = () => {
  // stats and variables
  const editor = useRef(null);
  const params = useParams();
  const links = [
    { name: "الصفحات", link: "/website/pages" },
    { name: "تعديل", link: "" },
  ];

  // Use form
  const {
    reset,
    watch,
    errors,
    setValue,
    register,
    handleSubmit,
    isSubmitting,
  } = useCustomForm(defaultValues, schema);

  const { error, fetchData } = useFetchData({
    fill: reset,
    reset: reset,
    fun: getPage,
    id: params.id,
  });

  return (
    <>
      {/* error alert */}
      <ErrorAlert reload={fetchData} show={error} />
      <Header title="تعديل الصفحة " links={links} />

      <form onSubmit={handleSubmit((data) => updatePage(data, params.id))}>
        <Card>
          <div className="grid gap-5 p-5 lg:grid-cols-3">
            <Input
              label="عنوان الصفحة"
              error={errors.pageTitle}
              input={register("pageTitle")}
            />

            <Input
              star
              label="رابط خارجى"
              error={errors.externalPageUrl}
              input={register("externalPageUrl")}
            />

            <Input
              star
              label="ترتيب الصفحة"
              error={errors.order}
              input={register("order")}
            />

            <SwitchInput
              label="نشط"
              checked={watch("isActive")}
              change={(value) => setValue("isActive", value)}
            />

            <SwitchInput
              label="اظهار في القائمة العلوية"
              checked={watch("showHeaderMenu")}
              change={(value) => setValue("showHeaderMenu", value)}
            />

            <SwitchInput
              label="اظهار القائمة السفلية"
              checked={watch("showLowerMenu")}
              change={(value) => setValue("showLowerMenu", value)}
            />
          </div>
        </Card>

        <Card title="محتوى الصفحة">
          <JoditEditor
            tabIndex={1}
            ref={editor}
            config={editorConfigOptions}
            value={watch("summary")}
            onChange={(newContent) => setValue("summary", newContent)}
          />
          <ErrorMessage value={errors.summary?.message} />
        </Card>

        <Button isLoading={isSubmitting} type="submit" title="حفظ البيانات" />
      </form>
    </>
  );
};

export default Edit;
